export const SUCCESS = 'success'
export const DANGER = 'error'
export const DATE_FORMATER = "MM/dd/yyyy"
export const AdminAccess = 1
export const StaffAccess = 2
export const MarketingAccess = 3
export const SuperAdminAccess = 4

/* Vendor portal user roles.
 * A vendor user can hold more than one of these, so vendor_users.role_id is a
 * string of comma separated ids ("1,3,5") - not a single foreign key.
 * Keep in sync with VENDOR_USER_ROLES in
 * hra-nodejs/vendor_portal/utilities/constant.js */
export const VendorSharedTicketAccess = "1"
export const VendorUpdateTicketStatusAccess = "2"
export const VendorDownloadMemberExcelAccess = "3"
export const VendorUploadDocumentAccess = "4"
export const VendorDownloadDocumentAccess = "5"
export const VendorViewMemberListAccess = "6"

export const VENDOR_USER_ROLES = [
  { value: VendorSharedTicketAccess, label: "Shared Ticket" },
  { value: VendorUpdateTicketStatusAccess, label: "Update Ticket Status" },
  { value: VendorViewMemberListAccess, label: "View Member List" },
  { value: VendorDownloadMemberExcelAccess, label: "Download Member Excel" },
  { value: VendorUploadDocumentAccess, label: "Upload Document" },
  { value: VendorDownloadDocumentAccess, label: "Download Document" },
]

/* actiontype values written to the vendor-logs table.
 * Keep in sync with ACTIONS in
 * hra-backend/hra-nodejs/utilities/VendorLog.js */
export const VENDOR_LOG_ACTION_LABELS = {
  "login": "Login",
  "logout": "Logout",
  "member-excel-download": "Member Excel Download",
  "ticket-share": "Ticket Share",
  "ticket-update": "Ticket Update",
  "document-upload": "Document Upload",
  "document-download": "Document Download",
  "document-share": "Document Shared",
  "document-status": "Document Status Changed",
  "password-change": "Password Change",
  "staff-add": "Vendor Added",
  "staff-update": "Vendor Updated",
  "staff-link": "Vendor Given Access",
  "staff-status": "Vendor Status Changed",
  "staff-resend-email": "Vendor Invite Resent",
}

/* the raw actiontype is shown as a fallback so an unmapped value is still
 * readable instead of coming out blank */
export const vendorLogActionLabel = (actionType) =>
  VENDOR_LOG_ACTION_LABELS[actionType] || actionType || "-"

/* The activity trail's readable line - "Parth Patel downloaded W9 Form" -
 * is built by the API, which is the only side that can turn a reference_id
 * into the document title or ticket name behind it. See describe() in
 * hra-backend/hra-nodejs/utilities/VendorLog.js; the browser just prints
 * log.message. */

/* The five groups the activity trail is filtered by. The API does the grouping
 * - it is only the key that travels, never the list of action types - so this
 * has to stay in step with CATEGORIES in
 * hra-backend/hra-nodejs/utilities/VendorLog.js. */
/* user_logs.usertype - "S" is a portal user (users table), "M" a member
 * (members table). The same /userLogList endpoint serves both; only this value
 * and the row id change. Keep in sync with USER_TYPES in
 * hra-backend/hra-nodejs/app/user-log/UserLogService.js */
export const USER_LOG_TYPE_STAFF = "S"
export const USER_LOG_TYPE_MEMBER = "M"

/* seconds -> "2h 15m" / "45m" / "30s"; null while a session is still open */
export const userLogDuration = (seconds) => {
  if (seconds === null || seconds === undefined) {
    return "-"
  }
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  if (hours > 0) {
    return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`
  }
  if (minutes > 0) {
    return `${minutes}m`
  }
  return `${seconds}s`
}

export const VENDOR_LOG_CATEGORY_OPTIONS = [
  { value: "store-login", label: "Store Login Logs" },
  { value: "download", label: "Download Logs" },
  { value: "upload", label: "Upload Logs" },
  { value: "share-email", label: "Share Email Logs" },
  { value: "staff-activity", label: "Vendor Activity Logs" },
]

/* "1,3" -> [{value,label}, ...] for react-select.
 * Walks VENDOR_USER_ROLES rather than the stored string so the roles always
 * come back in the same order - "3,1" and "1,3" are the same pair of roles and
 * should render alike down the Roles column - and so a role repeated in the
 * string only yields one option. */
export const vendorRoleOptionsFromIds = (roleIds) => {
  if (!roleIds) {
    return []
  }
  const ids = String(roleIds)
    .split(",")
    .map((roleId) => roleId.trim())
  return VENDOR_USER_ROLES.filter((role) => ids.includes(role.value))
}

/* "1,3" -> ["Shared Ticket", "Download Member Excel"] */
export const vendorRoleNamesFromIds = (roleIds) =>
  vendorRoleOptionsFromIds(roleIds).map((role) => role.label)